import moment from 'moment/moment';

const { api } = require('@cashew/utils');

const requestDelay = 10;
const pollingIterationsHelper = (
  from: string,
  to: string,
  delay: number
): number => {
  const dateFrom = moment(from).unix();
  const dateTo = moment(to).unix();
  return Math.ceil((dateTo - dateFrom) / delay);
};
const checkResultApi = (
  action: any,
  delay: number,
  iterations: number,
  id: number | string
) => {
  let timer = 0;
  const counts = iterations;

  const checkResult = () => {
    api
      .get({
        endpoint: `identity/merchant-update-request/${id}`,
      })
      .then((result: any) => {
        const { status } = result.data;
        if (status === 'PENDING') {
          if (counts - 1 > timer) {
            timer += 1;
            setTimeout(() => {
              checkResult();
            }, delay * 1000);
          }
        } else if (status === 'VERIFIED') {
          action('success');
        } else if (status === 'EXPIRED') {
          action('warning');
        }
      })
      .catch((e: any) => {
        console.log('ERROR', e);
      });
  };
  if (id && iterations !== 0) {
    checkResult();
  }
};

const updateEmailAPI = ({
  merchantId,
  emailAddress,
  newValue,
  token,
  dispatch,
  t,
  setEmailUpdateStatus,
  setShowUpdateEmailModal,
  setUpdatedEmailLoading,
}: any) => {
  setUpdatedEmailLoading(true);
  api
    .post({
      endpoint: 'identity/merchant-update-request',
      params: {
        field: 'EMAIL',
        merchantId,
        emailAddress,
        newValue,
      },
      headers: {
        Authorization: token,
      },
    })
    .then((response: any) => {
      setEmailUpdateStatus('info');
      setShowUpdateEmailModal(true);
      const pollingIterations = pollingIterationsHelper(
        response.data.createdAt,
        response.data.expiryAt,
        requestDelay
      );
      checkResultApi(
        setEmailUpdateStatus,
        requestDelay,
        pollingIterations,
        response.data.requestId
      );
    })
    .catch((err: any) => {
      console.log(err);
      let errorText = err?.response?.data?.message || err?.message;

      const { errorCode } = err?.response?.data;
      if (errorCode === '400.003.024' || errorCode === '400.003.030') {
        errorText = t(`customerDetails.error.${errorCode}`);
      }
      dispatch({
        type: 'OPEN_TOASTER',
        payload: {
          toasterTitle: t('customerDetails.errorToasterTitle'),
          toasterMessage: errorText,
          toasterType: 'error',
          toasterVisible: true,
          toasterDismiss: null,
        },
      });
    })
    .finally(() => setUpdatedEmailLoading(false));
};

const resendWelcomeEmailAPI = ({
  merchantId,
  token,
  dispatch,
  t,
  setWelcomeEmailLoading,
  setShowWelcomeConfirmModal,
}: any) => {
  setWelcomeEmailLoading(true);
  api
    .post({
      endpoint: 'identity/merchant/confirm-email/resend',
      params: {
        merchantId,
      },
      headers: {
        Authorization: token,
      },
    })
    .then(() => {
      setShowWelcomeConfirmModal(true);
    })
    .catch((err: any) => {
      const errorText = err.response.data.message || err.message;
      dispatch({
        type: 'OPEN_TOASTER',
        payload: {
          toasterTitle: t('customerDetails.errorToasterTitle'),
          toasterMessage: errorText,
          toasterType: 'error',
          toasterVisible: true,
          toasterDismiss: null,
        },
      });
    })
    .finally(() => setWelcomeEmailLoading(false));
};
const paymentOptionsAPI = ({
  storeId,
  token,
  setLoading,
  setPaymentOptionsList,
}: any) => {
  setLoading(true);
  api
    .get({
      endpoint: `products/store/${storeId}/payment-options`,
      params: {
        storeId,
      },
      headers: {
        Authorization: token,
      },
    })
    .then((resp: any) => {
      setPaymentOptionsList(resp?.data);
    })
    .catch((err: any) => {
      console.log(err);
    })
    .finally(() => setLoading(false));
};
const getKycConfigAPI = ({
  storeId,
  token,
  setKycDocumentsCheck,
  setKycFaceCheck,
}: any) => {
  api
    .get({
      endpoint: `stores/${storeId}/kyc-config`,
      headers: {
        Authorization: token,
      },
    })
    .then((resp: any) => {
      setKycDocumentsCheck(resp.data.kycEnabled);
      setKycFaceCheck(resp.data.faceRecognitionEnabled);
    })
    .catch((err: any) => {
      console.log(err);
    });
};
const checkMerchantActivationStatus = ({
  merchantId,
  token,
  setMerchantActivationStatus,
}: any) => {
  api
    .get({
      endpoint: `identity/merchant/${merchantId}/status`,
      headers: {
        Authorization: token,
      },
    })
    .then((resp: any) => {
      setMerchantActivationStatus(resp.data.status);
    })
    .catch((err: any) => {
      console.log(err);
    });
};
const updateKycConfigAPI = ({
  storeId,
  token,
  kycEnabled,
  faceRecognitionEnabled,
  dispatch,
}: any) => {
  api
    .patch({
      endpoint: `stores/${storeId}/kyc-config`,
      headers: {
        Authorization: token,
      },
      params: {
        kycEnabled,
        faceRecognitionEnabled,
      },
    })
    .then(() => {
      dispatch({
        type: 'OPEN_TOASTER',
        payload: {
          toasterTitle: 'Kyc options',
          toasterMessage: 'Kyc options updated successfully.',
          toasterType: 'success',
          toasterVisible: true,
          toasterDismiss: null,
        },
      });
    })
    .catch((err: any) => {
      console.log(err);
    });
};
export {
  updateEmailAPI,
  resendWelcomeEmailAPI,
  paymentOptionsAPI,
  getKycConfigAPI,
  updateKycConfigAPI,
  checkMerchantActivationStatus,
};
